import { IAPIResponse } from "./../config";
import { VehicleOverviewModel } from "./../../booking/models/vehicle-overview.model";
import { SearchBookingModel } from "./../../booking/models/search-booking.model";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, UserRoles, DataListModel } from "../config";

// saveAs variable is used for the external javascript library reference to save the csv file
const saveAs = require("file-saverjs");
//declare var saveAs: any;
declare var RemoveBranding: any;
@Injectable()
export class AuthService {
  public redirectUrl: string;
  public redirectMsg: string;
  public searchBookingModel: SearchBookingModel;
  public vehicleOverviewModel: VehicleOverviewModel[];

  public MODULE_NAME = {
    PersonBatchUpload: "PersonBatchUpload",
    DirectDebitFile: "DirectDebitFile",
    CreateOrganization: "CreateOrganization",
    MAINTAINANCE_PLANNING_REPORT: "MAINTAINANCE_PLANNING_REPORT",
    REVENUE_PER_VEHICLE_REPORT: "REVENUE_PER_VEHICLE_REPORT",
    TRIP_DATA_REPORT: "TRIP_DATA_REPORT",
    VEHICLE_OCCUPENCY_REPORT: "VEHICLE_OCCUPENCY_REPORT",
    SnailTrailReport: "SnailTrailReport",
  };

  constructor(private http: Http, private router: Router) {}

  public isLoggedIn() {
    return localStorage.getItem("access_token") ? true : false;
  }
  
  public accessToken() : string{
    return localStorage.getItem("access_token");
  }

  public isAuthorized(role: string) {
    let currentRole = localStorage.getItem("current_role");
    return currentRole && currentRole.toUpperCase() == role.toUpperCase()
      ? true
      : false;
  }
  public IsAdmin() {
    let currentRole = localStorage.getItem("current_role");
    return currentRole &&
      currentRole.toUpperCase() == UserRoles.ADMIN.toUpperCase()
      ? true
      : false;
  }

  public IsWeGoAdmin() {
    let currentRole = localStorage.getItem("current_role");
    return currentRole &&
      currentRole.toUpperCase() == UserRoles.WEGOADMIN.toUpperCase()
      ? true
      : false;
  }

  public IsCompanyAdmin() {
    let currentRole = localStorage.getItem("current_role");
    return currentRole &&
      currentRole.toUpperCase() == UserRoles.COMPANYADMIN.toUpperCase()
      ? true
      : false;
  }

  public IsGroupAdmin() {
    let currentRole = localStorage.getItem("current_role");
    return currentRole &&
      currentRole.toUpperCase() == UserRoles.GROUPADMIN.toUpperCase()
      ? true
      : false;
  }

  public IsOrganizationAdmin() {
    let currentRole = localStorage.getItem("current_role");
    return currentRole &&
      currentRole.toUpperCase() == UserRoles.ORGANIZATIONADMIN.toUpperCase()
      ? true
      : false;
  }

  public IsDriver() {
    let currentRole = localStorage.getItem("current_role");
    return currentRole &&
      currentRole.toUpperCase() == UserRoles.DRIVER.toUpperCase()
      ? true
      : false;
  }

  public GetCurrentRole(): string {
    let currentRole = localStorage.getItem("current_role");
    if (currentRole) return currentRole;
    else return;
  }

  public GetHighestRoleLevel(): number {
    let highest_role_level = localStorage.getItem("highest_role_level");
    if (highest_role_level) return parseInt(highest_role_level);
    else return 100;
  }

  public GetPersonHashId() {
    let personHashId = localStorage.getItem("personMasterHashId");
    if (personHashId) return personHashId;
    else return;
  }

  public GetUserSetting() {
    let userSetting = localStorage.getItem("user_setting");
    if (userSetting) return JSON.parse(userSetting);
    else return;
  }

  public getTwoFaMethod() {
    let twoFamethod = localStorage.getItem("TwoFa_method");
    if (twoFamethod) return twoFamethod;
    else return;
  }

  public GetURL(url: string): string {
    let currentRole = localStorage.getItem("current_role") || "";
    if (currentRole.toUpperCase() == UserRoles.ADMIN) return "/admin/" + url;
    if (currentRole.toUpperCase() == UserRoles.WEGOADMIN)
      return "/wegoadmin/" + url;
    else if (currentRole.toUpperCase() == UserRoles.COMPANYADMIN)
      return "/cadmin/" + url;
    else if (currentRole.toUpperCase() == UserRoles.GROUPADMIN)
      return "/gadmin/" + url;
    else if (currentRole.toUpperCase() == UserRoles.DRIVER)
      return "/driver/" + url;
    else if (currentRole.toUpperCase() == UserRoles.ORGANIZATIONADMIN)
      return "/orgadmin/" + url;
    else return "/" + url;
  }

  public GetNotificationCount() {
    let getNotificationInboxListUrl = WeGoConfig.API_GET_NOTIFICATION_COUNT;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getNotificationInboxListUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public ResetNotificationCount() {
    let getNotificationInboxListUrl =
      WeGoConfig.API_GET_RESET_NOTIFICATION_COUNT;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getNotificationInboxListUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public Login(userName: string, password: string): Observable<any> {
    let getAccessToken = WeGoConfig.API_GET_LOGIN_ACCESS_TOKEN;
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
    });

    // headers.append("computerId", computerId);

    let options = new RequestOptions({ headers: headers });
    let body =
      "grant_type=password" +
      "&username=" +
      encodeURIComponent(userName) +
      "&password=" +
      encodeURIComponent(password) +
      "&client_id=" +
      WeGoConfig.API_CLIENT_ID;

    return this.http
      .post(getAccessToken, body, options)
      .map((res) => {
        let body = res.json();
        return body || {};
      })
      .map((res) => {
        console.log(res);
        if (res) {
          localStorage.setItem("access_token", res.access_token);
          localStorage.setItem("refresh_token", res.refresh_token);
          localStorage.setItem("personMasterHashId", res.personMasterHashId);

          let computerId = localStorage.getItem("computerId");
          if (!computerId) {
            localStorage.setItem("computerId", res.userComputerId);
          }

          this.redirectMsg = "";
        }
        return res;
      })
      .catch((error) => {
        // let body = error.json();
        const body = { status: error.status };

        return Observable.throw(body);
      });
  }

  public Signout(): Observable<any> {
    let getBackOfficeSignoutUrl = WeGoConfig.API_GET_LOGOUT;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getBackOfficeSignoutUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public UpdateUserLanguagePreference(
    language: string
  ): Observable<IAPIResponse> {
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    let getPersonLanguageUrl =
      WeGoConfig.API_POST_UPDATE_PERSON_LANGUAGE + "?language=" + language;
    return this.http
      .get(getPersonLanguageUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public Logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("current_role");
    localStorage.removeItem("user_setting");
    localStorage.removeItem("personMasterHashId");
    localStorage.removeItem("itemsPerPage");
    localStorage.removeItem("language");
    localStorage.removeItem("driverSelectedMenu");
    this.redirectMsg = "";
    RemoveBranding();
  }

  public GetHeader(accept?: string, content?: string) {
    let acceptType = accept || "application/json";
    let contentType = content || "application/json";
    let access_token = localStorage.getItem("access_token");
    let authorization = access_token ? "Bearer " + access_token : "";
    let language = localStorage.getItem("language");
    let accept_language = language ? language : "en";
    let refresh = localStorage.getItem("refresh_token");
    let refresh_token = refresh ? refresh : "";
    let currentRole = localStorage.getItem("current_role");
    let current_role = currentRole ? currentRole : "";
    let computerId = localStorage.getItem("computerId");

    let headers = new Headers({
      "Content-Type": contentType,
      Accept: acceptType,
      Authorization: authorization,
      "Accept-Language": accept_language,
      RefreshToken: refresh_token,
      CurrentRole: current_role,
      ComputerId: computerId,
    });

    return headers;
  }

  // public GetHeaderVehicle(accept?: string, content?: string) {
  //   let acceptType = accept || 'application/json';
  //   let access_token = localStorage.getItem("access_token");
  //   let authorization = access_token ? 'Bearer ' + access_token : '';
  //   let language = localStorage.getItem("language");
  //   let accept_language = language ? language : 'en';
  //   let refresh = localStorage.getItem("refresh_token");
  //   let refresh_token = refresh ? refresh : '';
  //   let currentRole = localStorage.getItem("current_role");
  //   let current_role = currentRole ? currentRole : '';

  //   let headers = new Headers({
  //     'Content-Type': 'application/x-www-form-urlencoded',
  //     'Accept': acceptType,
  //     'Authorization': authorization,
  //     'Accept-Language': accept_language,
  //     'RefreshToken': refresh_token,
  //     'CurrentRole': current_role
  //   });

  //   return headers;
  // }

  public GetHeaderForFile(accept?: string) {
    let acceptType = accept || "application/json";
    let access_token = localStorage.getItem("access_token");
    let authorization = access_token ? "Bearer " + access_token : "";
    let language = localStorage.getItem("language");
    let accept_language = language ? language : "en";
    let refresh = localStorage.getItem("refresh_token");
    let refresh_token = refresh ? refresh : "";
    let currentRole = localStorage.getItem("current_role");
    let current_role = currentRole ? currentRole : "DRIVER";
    let computerId = localStorage.getItem("computerId");

    let headers: any = [];

    headers.push({ name: "Accept", value: acceptType });
    headers.push({ name: "Authorization", value: authorization });
    headers.push({ name: "Accept-Language", value: accept_language });
    headers.push({ name: "RefreshToken", value: refresh_token });
    headers.push({ name: "CurrentRole", value: current_role });
    headers.push({ name: "ComputerId", value: computerId });
    return headers;
  }

  public DownloadFile(fileName: string, data: string) {
    // let downloadLink = document.createElement("a");
    // downloadLink.setAttribute("href", uri);
    // downloadLink.setAttribute("download", fileName);
    // downloadLink.setAttribute("target", "_blank");
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // document.body.removeChild(downloadLink);
    var blob = new Blob([data], { type: "text/plain;charset=utf-8" });
    saveAs(blob, fileName);
  }

  public IsAuthorizeURL(
    permissionName: string,
    permissionType: string,
    entity: string = "",
    entityId: string = ""
  ): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_IS_AUTHORIZE_URL +
      "?permissionName=" +
      permissionName +
      "&permissionType=" +
      permissionType +
      "&entity=" +
      entity +
      "&entityId=" +
      entityId;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public IsAuthorizeForDualPermission(
    primaryPermissionName: string,
    primaryPermissionType: string,
    secondaryPermissionName: string,
    secondaryPermissionType: string,
    entity: string = "",
    entityId: string = ""
  ): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_IS_AUTHORIZE_FOR_DUAL_PERMISSION +
      "?primaryPermissionName=" +
      primaryPermissionName +
      "&primaryPermissionType=" +
      primaryPermissionType +
      "&secondaryPermissionName=" +
      secondaryPermissionName +
      "&secondaryPermissionType=" +
      secondaryPermissionType +
      "&entity=" +
      entity +
      "&entityId=" +
      entityId;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public IsAuthorizeFor(moduleName: string): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_IS_AUTHORIZE_FOR + "?moduleName=" + moduleName;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public GetBackOfficeMenu(): Observable<IAPIResponse> {
    let getPersonUrl = WeGoConfig.API_GET_BACKOFFICE_MENU;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public HandleAPIListInput(input?: DataListModel) {
    let queryString: string;
    if (input) {
      let searchField = "";
      if (input.searchField && input.searchField.length > 0) {
        input.searchField.forEach((element) => {
          searchField += "&searchField=" + element;
        });
      }

      queryString =
        "pageNo=" +
        input.currentPage +
        "&record=" +
        input.itemsPerPage + //WeGoConfig.GRID_MAX_DATA_SIZE
        "&sortField=" +
        input.sortType +
        "&sortReverse=" +
        input.sortReverse +
        "&searchTerm=" +
        encodeURIComponent(input.searchTerm) +
        searchField;
    }
    return queryString;
  }

  public HandleAPIResponse(res: Response) {
    let body = res.json();
    console.log(body);
    return body || {};
  }

  public HandleAPIError(error: any) {
    console.log(error);
    return Observable.throw(error.status);
  }

  public HandleErrorStatusCode(error: any) {
    if (error && error == "401") {
      this.Logout();
      this.redirectMsg =
        "You don’t have an access to this page. Please try again with different user Role. Thank you!! Login again.";
      this.router.navigate(["/"]);
    } else if (error && error == "403") {
      this.Logout();
      this.redirectMsg =
        "Your session has expired due to no activities on website. Please Login again.";
      this.router.navigate(["/"]);
    } else if (error && error == "404") {
      //this.Logout();
      this.router.navigate(["/NotFound"]);
    } else if (error && error == "412") {
      this.router.navigate(["/privacy-not-allow"]);
    } else if (error && error == "400") {
      return "Bad request error.";
    } else {
      return error;
    }
  }

  public RetriveFilter(
    key: string,
    dataListModel: DataListModel = null
  ): DataListModel {
    let prevParameters = localStorage.getItem(key);
    if (prevParameters) {
      localStorage.removeItem(key);
      return JSON.parse(prevParameters);
    } else {
      return new DataListModel();
    }
  }

  public AssignFromStorage(key: string, model: any): any {
    let prevParameters = localStorage.getItem(key);
    if (prevParameters) {
      localStorage.removeItem(key);
      return JSON.parse(prevParameters);
    } else {
      return model;
    }
  }

  public GetSearchParameters(
    datalistmodel: DataListModel,
    searchTerm: string,
    isReset: boolean
  ): DataListModel {
    datalistmodel.searchTerm = searchTerm;
    datalistmodel.currentPage = 1;

    if (isReset) {
      datalistmodel.sortType = "";
      datalistmodel.sortReverse = false;
      datalistmodel.itemsPerPage = WeGoConfig.GRID_MAX_DATA_SIZE;
    }

    return datalistmodel;
  }

  public SetFilter(key: string, dataListModel: DataListModel) {
    localStorage.setItem(key, JSON.stringify(dataListModel));
  }

  public SaveToStorage(key: string, model: any) {
    localStorage.setItem(key, JSON.stringify(model));
  }

  public CheckAccountActivationTermsConditionStatus(): Observable<IAPIResponse> {
    const getUrl =
      WeGoConfig.API_GET_CHECK_ACCOUNT_ACTIVATION_TERMS_CONDITION_STATUS;
    const options = { headers: this.GetHeader() };
    return this.http
      .get(getUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public CheckAccountActivationPrivacyStatus(): Observable<IAPIResponse> {
    const getUrl =
      WeGoConfig.API_GET_CHECK_ACCOUNT_ACTIVATION_PRIVACYSTATEMENT_STATUS;
    const options = { headers: this.GetHeader() };
    return this.http
      .get(getUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public GetResourceLabel(accept_language: string): Observable<IAPIResponse> {
    let getInvoiceUrl = WeGoConfig.API_GET_RESOURCE_LABEL;
    let headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      "Accept-Language": accept_language,
    });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInvoiceUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public DownloadXlsFile(fileName: string, data: string) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, fileName);
  }

  public GetTelephoneCountry(): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_TELEPHONE_COUNTRY;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public GetPersonCountry(): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_PERSON_COUNTRY_LIST;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public IsAuthorizedForPrePostQuestion(
    primaryPermissionName: string,
    primaryPermissionType: string,
    secondaryPermissionName: string,
    secondaryPermissionType: string,
    entity: string = "",
    entityId: string = ""
  ): Observable<IAPIResponse> {
    let getPersonUrl =
      WeGoConfig.API_GET_IS_AUTHORIZE_FOR_PREPOST_QUESTION +
      "?primaryPermissionName=" +
      primaryPermissionName +
      "&primaryPermissionType=" +
      primaryPermissionType +
      "&secondaryPermissionName=" +
      secondaryPermissionName +
      "&secondaryPermissionType=" +
      secondaryPermissionType +
      "&entity=" +
      entity +
      "&entityId=" +
      entityId;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPersonUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public GetSsoConfig(subdomain: string): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_SSO_CONFIG + "?subdomain=" + subdomain;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.HandleAPIResponse)
      .catch(this.HandleAPIError);
  }

  public GetSsoTokenAssertion(token: string): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_ASSERTION_SSO + token;
    let headers = this.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getUrl, options)
      .map((res) => {
        let body = res.json();
        return body || {};
      })
      .map((res) => {
        console.log(res);
        if (res) {
          localStorage.setItem("access_token", res.access_token);
          localStorage.setItem("refresh_token", res.refresh_token);
          localStorage.setItem("personMasterHashId", res.personMasterHashId);

          let computerId = localStorage.getItem("computerId");
          if (!computerId) {
            localStorage.setItem("computerId", res.userComputerId);
          }

          this.redirectMsg = "";
        }
        return res;
      })
      .catch((error) => {
        const body = { status: error.status };
        return Observable.throw(body);
      });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/auth.service.ts